module.exports = __webpack_public_path__ + "img/yt.3a8983b8.svg";